export const Wordmark = ({ className = "h-12 lg:h-[4.5rem]" }) => (
  <img src="/images/yallahero-logo-v2.webp" alt="يلّا هيرو Yalla Hero" className={`${className} w-auto select-none`} draggable="false" />
);
